import List from "@/components/list";
import Bus from "./Bus.js";
import { tableBaseProps } from '@/utils/common.js';

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const handleEdit = listeners["handleEdit"] || function () { };
  const dealDelete = listeners["dealDelete"] || function () { };
  const setDown = listeners["setDown"] || function () { };
  const handleShare = listeners["handleShare"] || function () { };
  
  const bizType = args.props.bizType;
  const deptLevelCode = args.props.deptLevelCode;
  function handleDelete({ row }) {
    Bus.$emit("deleteConfigInfo", row);
  }
  function handleIsNew({ row }) {
    Bus.$emit("handleIsNew", row);
  }
  function handleIsHot({ row }) {
    Bus.$emit("handleIsHot", row);
  }
  const Deal = ({ props: { vo } }) => {
      let dealConf = [];
      // 小程序特色内容
      if (bizType == 22) {
        let isMyCollege = vo.row.originDeptLevelCode == deptLevelCode;
        if (isMyCollege && vo.row.onlineStatus == 0){
          // 版权方为本学院 && 下线状态
          dealConf.push(["icon-edit", "编辑", () => handleEdit(vo.row), "clientIndexConfig:save"]);
        } else {
          dealConf.push(["icon-edit-disable", "编辑", () => { }, "clientIndexConfig:save"]);
        }
        if (vo.row.onlineStatus == 0) {
          // 下线状态
          dealConf.push(["icon-delete", "删除", () => dealDelete(vo.row), "clientIndexConfig:delete"]);
          dealConf.push(["icon-up", "上线", () => setDown(vo.row.uuid, 1), "clientIndexConfig:updateOnlineStatus"]);
        } else {
          dealConf.push(["icon-delete-disable", "删除", () => {}, "clientIndexConfig:delete"]);
          dealConf.push(["icon-down", "下线", () => setDown(vo.row.uuid, 0), "clientIndexConfig:updateOnlineStatus"]);
        }
        if (isMyCollege){
          dealConf.push(["icon-share", "共享管理", () => handleShare(vo.row), "clientIndexConfig:share"]);
        } else {
          dealConf.push(["icon-share-none", "共享管理", () => {}, "clientIndexConfig:share"]);
        }
      } else {
        dealConf = [
          ["icon-delete", "移除", () => handleDelete(vo), "configInfo:delete"]
        ];
        if (bizType == 10 || bizType == 14 || bizType == 16) {
          if (vo.row.isNew == 1) {
            dealConf.push([
              "icon-unnew",
              "取消最新",
              () => handleIsNew(vo),
              "configInfo:setNewAndHot"
            ]);
          } else {
            dealConf.push([
              "icon-new",
              "设置最新",
              () => handleIsNew(vo),
              "configInfo:setNewAndHot"
            ]);
          }
        }
      }
  
      return (
        <div class="deal-group">
          {dealConf.map(item => (
            <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
              <i class={item[0]} onClick={item[2]}></i>
            </el-tooltip>
          ))}
        </div>
      );
    };

  const Img = ({ props: { vo } }) => {
    let url = vo.row.coverUrl;
    return (
      <div >
        <el-image 
          style="width: 160px; height: 90px; cursor: pointer" 
          src={url} 
          fit={'contain'} 
          lazy
          preview-src-list={[url]}
        ></el-image>
      </div>
    );
  };

  let AccountTableConfig = [];
  if (bizType == 22) {
    AccountTableConfig = [
      {
        type: "selection",
        label: "main",
      },
      {
        label: "名称",
        prop: "name",
        showOverflowTooltip: true
      },
      {
        label: "icon图片",
        width: "200",
        render: vo => <Img vo={vo} />
      },
      {
        label: "跳转类型",
        prop: "skipTypeStr"
      },
      {
        label: "状态",
        prop: "onlineStatusStr"
      },
      {
        label: "版权方",
        prop: "originDeptName"
      },
      {
        label: "已共享学院",
        prop: "sharedDeptNames"
      },
      {
        label: "操作",
        fixed: "right",
        render: vo => <Deal vo={vo} />
      }
    ];
  } else {
    AccountTableConfig = [
      {
        label: "名称",
        prop: "name",
        showOverflowTooltip: true
      },
      {
        label: "类型",
        prop: "bizTypeName"
      },
      {
        label: "状态",
        prop: "onlineStatusName"
      },
      {
        label: "操作",
        fixed: "right",
        render: vo => <Deal vo={vo} />
      }
    ];
    if (bizType == 12  || bizType == 13 || bizType == 18) {
      AccountTableConfig.splice(0, 0, {
        type: "selection",
        label: "main",
      })
    }
    if (bizType == 10 || bizType == 14 || bizType == 16) {
      AccountTableConfig.splice(4, 0, {
        label: "是否最新",
        prop: "isNewName"
      })
    }
  }

  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
